import React from 'react'
import cx from 'classnames'

import NavigationBarFlyout from './NavigationBarFlyout'

import { TNavItem } from '../../../../types/mainNavigation'

const NavigationBarItem: React.FC<
  TNavItem & {
    onClick: (e: React.MouseEvent) => void
    isActive: boolean
    index: number
    isFirst: boolean
    isLast: boolean
  }
> = (props) => {
  const labelProps = {
    className: 'flex items-center cursor-pointer',
    href: props.isExternal ? props.url : undefined,
    id: props.trackingId,
    children: props.label,
  }
  return (
    <li
      className={cx('border-b-2 transition-colors duration-150', {
        'ml-0': props.index === 0,
        'mr-0': props.isLast,
        'border-brand-orange': props.isActive,
        'border-transparent': !props.isActive,
        'text-sale-red': props.isHighlight,
      })}
      onClick={!props.isExternal ? props.onClick : undefined}
    >
      {props.isExternal && <a {...labelProps} />}
      {!props.isExternal && <span {...labelProps} />}
      <NavigationBarFlyout {...props} />
    </li>
  )
}

export default NavigationBarItem
